import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import articalIcon from "../assets/img/article-icon.png";

interface FavouriteArticalsProps {
  article: any[];
  title: string;
  getArtical: (value: any) => void;
}

export const FavouriteArticals: React.FC<FavouriteArticalsProps> = ({
  article,
  title,
  getArtical,
}) => {
  const { t } = useTranslation();

  const [displayCount, setDisplayCount] = useState(4);

  const showMoreButton = () => {
    setDisplayCount(displayCount + 5); // Increase by a certain number
  };

  const showLessButton = () => {
    setDisplayCount(4); // Reset to initial display count
  };

  return (
    <div>
      {article?.length > 0 ? (
        <div>
          <div>
            <p
              style={{
                fontFamily: "ChanakyaUni",
                fontWeight: 700,
                fontStyle: "normal",
                color: "#b42a38",
                fontSize: "26px",
                margin: "0 0 10px",
              }}
            >
              {title}
            </p>
            <div className="row" style={{ marginBottom: "21px", padding: "0 15px" }}>
              {article.slice(0, displayCount).map((artical: any) => (
                <div
                  className="col-3"
                  style={{
                    marginTop: "15px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <div
                    className="favpagebooks"
                    onClick={() => {
                      getArtical(artical);
                    }}
                    style={{
                      textAlign: "center",
                      padding: "20px 30px",
                      height: "145px",
                      margin: "0 0 22px",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <div>
                        <img
                          style={{
                            width: "28px",
                            height: "34px",
                            cursor: "pointer",
                            borderRadius: 0,
                          }}
                          src={articalIcon}
                          alt="articalimg"
                          width="60"
                        />
                        <p>
                          {artical?.name?.length > 30
                            ? artical?.name.slice(0, 30) + "..."
                            : artical?.name}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          {article?.length > 4 && (
            <div
              style={{
                textAlign: "center",
                margin: "20px 0 0 0",
              }}
            >
              {displayCount < article?.length ? (
                <button className="favitems" onClick={showMoreButton}>
                  {t("all_tr")} {article?.length} {t("Article_tr")}{" "}
                  {t("view_tr")}
                </button>
              ) : (
                <button className="favitems" onClick={showLessButton}>
                  {t("show_less_tr")}
                </button>
              )}
            </div>
          )}
        </div>
      ) : (
        ""
      )}
    </div>
  );
}; 